<template>
    <div>
        <div class="body-overlay"></div>
        <div id="wrapper" class="clearfix" v-show="data.application_enc_id">
            <div class="main-content">
                <section class="overlape dark-color">
                    <div data-velocity="-.1"
                         style="background: url('https://www.empoweryouth.com/assets/themes/ey/images/backgrounds/default_cover.png') repeat scroll 50% 422.28px transparent;background-size: 100% 100% !important;background-repeat: no-repeat;"
                         class="parallax scrolly-invisible no-parallax"></div>
                    <div class="background-container">
                        <div class="row m-0">
                            <div class="col-lg-12 p-0">
                                <div class="inner-header">
                                    <div class="profile_icons">
                                        <img v-bind:src="profile_icon"/>
                                    </div>
                                    <h3>{{ name }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="container">
                        <div class="row m-0">
                            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                <div class="job-single-sec">
                                    <div class="job-single-head2">
                                        <div class="job-overview">
                                            <h3>{{ application_type }} Overview</h3>
                                            <ul>
                                                <li><i class="fas fa-puzzle-piece"></i>
                                                    <h3>Profile</h3><span>{{ cat_name }}</span></li>
                                                <li v-if="industry"><i class="fas fa-puzzle-piece"></i>
                                                    <h3>Preferred Industry</h3>
                                                    <span>{{ industry }}</span></li>
                                                <li v-if="designation"><i class="fas fa-thumbtack"></i>
                                                    <h3>Designation</h3><span>{{ designation }}</span></li>
                                                <li v-if="job_type"><i class="fas fa-suitcase"></i>
                                                    <h3>{{ application_type }} Type</h3><span>{{ job_type }}</span></li>
                                                <li v-if="application_type == 'Job' && wage_type"><i
                                                    class="far fa-money-bill-alt"></i>
                                                    <h3>Offered Salary ({{ wage_type }})</h3>
                                                    <span>{{ amount }}</span></li>
                                                <li v-if="application_type == 'Internship' && wage_type"><i
                                                    class="fas fa-puzzle-piece"></i>
                                                    <h3>Stipend Type</h3>
                                                    <span>{{ wage_type }}</span></li>
                                                <li v-if="application_type == 'Internship' && amount"><i
                                                    class="far fa-money-bill-alt"></i>
                                                    <h3>Offered Stipend</h3>
                                                    <span>{{ amount }}</span></li>
                                                <li v-if="preferred_gender"><i class="fas fa-mars-double"></i>
                                                    <h3>Gender</h3><span>{{ preferred_gender }}</span></li>
                                                <li v-if="vacancies != 0"><i class="fas fa-chart-line"></i>
                                                    <h3>Total Vacancies</h3>
                                                    <span>{{ vacancies }}</span></li>
                                                <li v-if="data.internship_duration">
                                                    <i class="fas fa-stopwatch"></i>
                                                    <h3>Internship Duration</h3>
                                                    <span>{{ data.internship_duration }} {{data.internship_duration_type}}</span>
                                                </li>
                                                <li v-if="data.has_placement_offer && data.has_placement_offer != 0">
                                                    <i class="fas fa-user-check"></i>
                                                    <h3>Has Placement Offer</h3>
                                                    <span>Yes</span>
                                                </li>
<!--                                                <li v-if="data.pre_placement_offer">-->
<!--                                                    <i class="fas fa-stopwatch"></i>-->
<!--                                                    <h3>Pre Placement Offer</h3>-->
<!--                                                    <span>Yes</span>-->
<!--                                                </li>-->
                                                <li v-if="placement_locations.length" class="list-data"><i
                                                    class="fas fa-map-marker-alt"></i>
                                                    <h3>Locations</h3>
                                                    <span v-for="p in placement_locations"
                                                          class="width-auto"> {{ p.name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!--                                    <div class="job-details" v-if="this.$store.getters.getUserType != 'Individual'">-->
                                    <!--                                        <h3>Interview Processes</h3>-->
                                    <!--                                    </div>-->
                                    <div class="job-details" v-if="working_days">
                                        <h3>Working Days</h3>
                                        <div class="week-days">
                                            <ul>
                                                <li class="active" v-if="working_days.includes(1)">
                                                    <span>Monday</span>
                                                    <h2>M</h2>
                                                </li>
                                                <li class="active" v-if="working_days.includes(2)">
                                                    <span>Tuesday</span>
                                                    <h2>T</h2>
                                                </li>
                                                <li class="active" v-if="working_days.includes(3)">
                                                    <span>Wednesday</span>
                                                    <h2>W</h2>
                                                </li>
                                                <li class="active" v-if="working_days.includes(4)">
                                                    <span>Thursday</span>
                                                    <h2>T</h2>
                                                </li>
                                                <li class="active" v-if="working_days.includes(5)">
                                                    <span>Friday</span>
                                                    <h2>F</h2>
                                                </li>
                                                <li class="active" v-if="working_days.includes(6)">
                                                    <span>Saturday</span>
                                                    <h2>S</h2>
                                                    <p v-html="data.saturday_frequency"></p>
                                                </li>
                                                <li class="active" v-if="working_days.includes(7)">
                                                    <span>Sunday</span>
                                                    <h2>S</h2>
                                                    <p v-html="data.sunday_frequency"></p>
                                                </li>
                                            </ul>
                                        </div>
                                        <h3>Work Timing</h3>
                                        <div class="time-bar-inner col-md-12 col-sm-12 col-xs-12">
                                            <div class="working-time-from">
                                                {{ timings_from }}
                                            </div>
                                            <div class="working-time-title">
                                                Working Hours
                                            </div>
                                            <div class="working-time-to">
                                                {{ timings_to }}
                                            </div>
                                        </div>
                                        <h3 class="mt-30">Required Knowledge, Skills, and Abilities</h3>
                                        <div class="tags-bar">
                                            <span v-for="s in skills">{{ s.skill }} </span>
                                        </div>
                                        <h3>{{ application_type }} Description</h3>
                                        <ul>
                                            <li v-for="jd in job_description"> {{ jd.job_description }}</li>
                                        </ul>
                                        <h3 v-if="edu_required.length">Education</h3>
                                        <ul v-if="edu_required.length">
                                            <li v-for="e in edu_required"> {{ e.educational_requirement }}</li>
                                        </ul>
                                        <h3 v-if="data.description">Other Details</h3>
                                        <ul v-if="data.description">
                                            <li> {{ data.description }}</li>
                                        </ul>
                                    </div>
                                    <div class="job-details" v-if="data && data.applicationEmployeeBenefits.length">
                                        <h3>Benefits</h3>
                                        <div class="col-md-3" v-for="bb in data.applicationEmployeeBenefits">
                                            <div class="benefit-box">
                                                <div class="bb-icon">
                                                    <img :src="bb.icon">
                                                </div>
                                                <div class="bb-text">
                                                    {{ bb.benefit }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="job-overview">
                                        <h3>Interview Details</h3>
                                        <ul style="border:0px;">
                                            <li><i class="fas fa-map-marker-alt"></i>
                                                <h3>Interview Locations</h3><span
                                                    v-for="i in interview_locations"> {{ i.name }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="job-single-head2" v-if="placement_locations.length">
                                        <h4 class="p-location-heading">Navigate to Placement Location</h4>
                                        <ul class="p-locations">
                                            <li v-for="p in placement_locations">
                                                <a target="_blank" class="map-navigate" title="Navigate to Google Map"
                                                   v-bind:href="'http://maps.google.com/maps?daddr=' + p.latitude + ',' + p.longitude">
                                                    <img
                                                        src="https://www.empoweryouth.com/assets/themes/ey/images/pages/jobs/city-map.png"/>
                                                    <span>{{ p.name }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 z-index-9">
                                <div class="job-single-head style2 overlay-top">
                                    <div class="job-thumb">
                                        <router-link :to="{path: '/profile?slug=' + org_slug}">
                                            <img v-bind:src="logo" id="logo_img" alt=""/>
                                        </router-link>
                                    </div>
                                    <div class="job-head-info">
                                        <router-link :to="{path: '/profile?slug=' + org_slug}">
                                            <h4 v-html="organization_name"></h4>
                                        </router-link>
                                        <div class="organization-details">
                                            <!--            <h4>Company Detail</h4>-->
                                            <!--                                            <p><i class="fas fa-envelope"></i>{{org_email}}</p>-->
                                        </div>
                                    </div>
                                    <div class="actions-main" v-if="this.$store.getters.getUserType == 'Individual'">
                                        <a href="JavaScript:void(0);" @click="showApplyModal()"
                                           v-if="!hasApplied && !data.is_closed && !data.is_blocked"
                                           class="apply-job-btn apply-btn hvr-icon-pulse btn-parent fixed-apply-button">
                                            <i class="fas fa-paper-plane hvr-icon"></i>
                                            Apply for {{ application_type }}
                                        </a>
                                        <a href="JavaScript:void(0);" v-else-if="hasApplied"
                                           class="apply-job-btn apply-btn hvr-icon-pulse btn-parent">
                                            <i class="fas fa-check hvr-icon"></i>
                                            Applied
                                        </a>
                                        <a href="JavaScript:void(0);" v-else-if="data.is_blocked"
                                           class="apply-job-btn apply-btn hvr-icon-pulse btn-parent fixed-apply-button"
                                           @click="alertModal('You have already been hired for '+application_type+' so you can\'t apply for any other ' + application_type +'.')">
                                            <i class="fas fa-paper-plane hvr-icon"></i>
                                            Apply for {{ application_type }}
                                        </a>
                                        <div class="sub-actions" v-if="!data.is_closed">
                                            <a href="JavaScript:void(0);" @click.prevent="shortlist($event)"
                                               v-if="!isshortlisted" v-bind:data-key="application_enc_id"
                                               class="add-or-compare hvr-icon-pulse shortlist_job ">
                                                <i class="far fa-heart hvr-icon"></i>
                                                Shortlist
                                            </a>
                                            <a href="JavaScript:void(0);" @click.prevent="shortlist($event)"
                                               v-if="isshortlisted" v-bind:data-key="application_enc_id"
                                               class="add-or-compare hvr-icon-pulse shortlist_job ">
                                                <i class="far fa-heart hvr-icon"></i>
                                                Shortlisted
                                            </a>
                                        </div>
                                        <div class="sub-actions" v-else>
                                            <a href="JavaScript:void(0);"
                                               class="add-or-compare hvr-icon-pulse shortlist_job">
                                                <i class="far fa-check-square hvr-icon"></i>
                                                Recruitment Completed
                                            </a>
                                        </div>
                                    </div>
                                    <div class="actions-main" v-else-if="this.$store.getters.getUserType">
                                        <div class="applied-count" v-if="data.applied_count != 0">
                                            <router-link
                                                :to="{path: '/dashboard/application-processes?id=' + data.slug}">
                                                {{ data.applied_count }} Students Applied
                                            </router-link>
                                        </div>
                                        <div class="disabled-section">
                                            <a href="JavaScript:void(0);"
                                               @click="alertModal('Only students can apply for this job.')"
                                               class="apply-job-btn apply-btn hvr-icon-pulse">
                                                <i class="fas fa-paper-plane hvr-icon"></i>
                                                Apply for {{ application_type }}
                                            </a>
                                            <div class="sub-actions">
                                                <a href="JavaScript:void(0);"
                                                   @click="alertModal('Only students can Shortlist this job')"
                                                   class="add-or-compare hvr-icon-pulse shortlist_job ">
                                                    <i class="far fa-heart hvr-icon"></i>
                                                    Shortlist
                                                </a>
                                            </div>
                                        </div>
                                        <div class="sub-actions margin-top-20"
                                             v-if="data.is_college_approved == 1 && data.is_college_deleted != 1">
                                            <a href="JavaScript:void(0);"
                                               class="apply-job-btn apply-btn hvr-icon-pulse disabled">
                                                <i class="fas fa-check"></i>
                                                Approved
                                            </a>
                                        </div>
                                        <div class="sub-actions margin-top-20" v-else-if="data.is_college_deleted == 1">
                                            <a href="JavaScript:void(0);"
                                               class="add-or-compare hvr-icon-pulse shortlist_job disabled">
                                                <i class="fas fa-times"></i>
                                                Rejected
                                            </a>
                                        </div>
                                        <div class="sub-actions margin-top-20" v-else-if="!data.is_closed">
                                            <a class="add-or-compare half-width primary" href="javascript:;"
                                               @click="accept($event, data.application_type, 'Accept')"
                                               :data-id="data.organization_enc_id" :data-key="data.application_enc_id">
                                                <i class="fas fa-check"></i>
                                                Accept
                                            </a>
                                            <a class="add-or-compare half-width" href="javascript:;"
                                               @click="accept($event, data.application_type, 'Reject')"
                                               :data-id="data.organization_enc_id" :data-key="data.application_enc_id">
                                                <i class="fas fa-times"></i>
                                                Reject
                                            </a>
                                        </div>
                                    </div>
                                    <div class="actions-main" v-else>
                                        <a href="JavaScript:void(0);"
                                           @click="showLoginModal()"
                                           class="apply-job-btn apply-btn hvr-icon-pulse fixed-apply-button btn-parent">
                                            <i class="fas fa-paper-plane hvr-icon"></i>
                                            Login to apply
                                        </a>
                                        <div class="sub-actions">
                                            <a href="JavaScript:void(0);"
                                               @click="showLoginModal()"
                                               class="add-or-compare hvr-icon-pulse shortlist_job ">
                                                <i class="far fa-heart hvr-icon"></i>
                                                Shortlist
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="margin-top-40 p-list text-center">
                                            <div class="social-heading text-white">Share</div>
                                            <div class="social-buttons">
                                                <a :href="'https://www.facebook.com/sharer.php?u=https://myecampus.in/detail?id=' + data_slug"
                                                   target="blank" class="social-margin">
                                                    <div class="social-icon facebook">
                                                        <i class="fab fa-facebook"></i>
                                                    </div>
                                                </a>
                                                <a :href="'https://api.whatsapp.com/send?text=https://myecampus.in/detail?id=' + data_slug"
                                                   target="blank" class="social-margin">
                                                    <div class="social-icon whatsapp">
                                                        <i class="fab fa-whatsapp"></i>
                                                    </div>
                                                </a>
                                                <a :href="'https://telegram.me/share/url?url=https://myecampus.in/detail?id=' + data_slug"
                                                   target="blank" class="social-margin">
                                                    <div class="social-icon twitter">
                                                        <i class="fab fa-telegram-plane"></i>
                                                    </div>
                                                </a>
                                                <a :href="'mailto:?&body=https://myecampus.in/detail?id=' + data_slug"
                                                   target="blank" class="social-margin">
                                                    <div class="social-icon pinterest">
                                                        <i class="far fa-envelope-open"></i>
                                                    </div>
                                                </a>
                                                <a :href="'https://myecampus.in/detail?id=' + data_slug"
                                                   @click.prevent="copyToClipboard($event)" class="social-margin">
                                                    <div class="social-icon copy">
                                                        <i class="far fa-copy" title="Tap to Copy"></i>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="margin-top-10 p-list text-center">
                                            <div class="wts-ap">
                                                <h3>Share on Whatsapp via Number</h3>
                                                <div class="input-wts">
                                                    <input type="text" id="wts-txt" class="form-control dash-input"
                                                           placeholder="+91 XX XXXX XXXX" @keypress="validateEnterKey">
                                                    <i class="fa fa-arrow-right" @click="openWhatsapp()"></i>
                                                </div>
                                            </div>
                                            <div class="down-img">
                                                <h3>Download Sharing Image</h3>
                                                <a :href="data.sharing_image" download target="_blank"><i
                                                    class="fa fa-download"></i> Download</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="data && data.applied_list.length">
                                    <div class="col-lg-12 col-xs-12 col-sm-12">
                                        <div class="portlet light margin-top-40">
                                            <div class="portlet-title tabbable-line">
                                                <div class="caption">
                                                    <span class="caption-subject font-dark bold uppercase">Applied Candidates</span>
                                                </div>
                                            </div>
                                            <div class="portlet-body">
                                                <div class="mt-comments">
                                                    <div class="mt-comment" v-for="al in data.applied_list">
                                                        <div class="mt-comment-img">
                                                            <img :src="al.image"></div>
                                                        <div class="mt-comment-body">
                                                            <div class="mt-comment-info">
                                                                <span class="mt-comment-author">{{
                                                                        al.first_name
                                                                    }} {{ al.last_name }}</span>
                                                                <div class="block-drp dropdown p-0">
                                                                    <button class="btn dropdown-toggle" type="button"
                                                                            data-toggle="dropdown">
                                                                        <i class="fas fa-ellipsis-v"></i>
                                                                    </button>
                                                                    <ul class="dropdown-menu">
                                                                        <li><a href="javascript:;"
                                                                               @click="changeCandStatus($event)"
                                                                               :data-key="al.applied_application_enc_id">Block</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <span class="mt-comment-date">{{ al.status }}</span>
                                                            </div>
                                                            <div class="mt-comment-text"> Round:- {{
                                                                    al.process_name
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div class="modal fade bs-modal-md in" id="modal" aria-hidden="true">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <form id="apply_form" v-on:submit.prevent="jobApply" method="post">
                                <div class="modal-header">
                                    <h4 class="modal-title">Fill Out The Details</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group field-jobapplied-location_pref required"
                                         v-if="placement_locations.length">
                                        <label class="control-label">Select Placement Location</label>
                                        <div class="placement-locations">
                                            <div class="pl-items" v-for="p in placement_locations">
                                                <input type="checkbox" v-bind:id="p.location_enc_id"
                                                       v-bind:value="p.city_enc_id" v-on:change="apply_location($event)"
                                                       class="pl-apply-item">
                                                <label v-bind:for="p.location_enc_id" class="checkbox-inline">
                                                    {{ p.name }}
                                                </label>
                                                <p class="help-block help-block-error"></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group field-jobapplied-check required has-success">
                                        <label class="control-label">Upload Resume</label>
                                        <div>
                                            <div id="jobapplied-check" role="radiogroup" aria-required="true"
                                                 aria-invalid="false">
                                                <label class="radio-inline">
                                                    <input type="radio" name="resSteps" value="0"
                                                           @change="showResumeSection($event)"> Use Existing One
                                                </label>
                                                <label class="radio-inline">
                                                    <input type="radio" name="resSteps" value="1"
                                                           @change="showResumeSection($event)"> Upload New
                                                </label>
                                            </div>
                                            <p class="help-block help-block-error"></p>
                                        </div>
                                    </div>
                                    <div id="new_resume" class="hidden">
                                        <div class="form-group field-resume_file required">
                                            <label class="control-label" for="marks">Upload Your CV In Doc,
                                                Docx,Pdf,Jpg,Jpeg,Png Format Only</label>
                                            <div class="field-resume_upload">
                                                <div class="file-upload-wrapper">
                                                    <input type="file" id="resume_upload" class="resume_upload"
                                                           name="resume" @change="uploadResume">
                                                </div>
                                            </div>
                                            <p class="error-msg" v-html="resumeError"></p>
                                        </div>
                                    </div>
                                    <div id="use_existing" class="hidden">
                                        <div class="row" v-if="data.resume_ids && data.resume_ids.length">
                                            <label id="warn" class="col-md-3">Select One</label>
                                            <div class="col-md-offset-1 col-md-10" v-for="rs in data.resume_ids">
                                                <div class="radio_questions">
                                                    <div class="inputGroup">
                                                        <input :id="rs.resume_enc_id" name="resume_list" type="radio"
                                                               :value="rs.resume_enc_id"/>
                                                        <label :for="rs.resume_enc_id"> {{ rs.title }} </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h3 v-else>No resume found pls upload</h3>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-primary sav_job">Save</button>
                                        <button type="button" class="btn btn-default" data-dismiss="modal">Close
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

<!--            <education-loan-webinar></education-loan-webinar>-->
<!--            <webinar-widget></webinar-widget>-->
        </div>
        <div class="container">
            <div class="col-md-12 margin-top-40 padd-top-50" style="margin-bottom: 500px;"
                 v-show="!data.application_enc_id">
                <div id="sectionIsLoading" class="sectionIsLoading">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <message-modal></message-modal>
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../public/js/toastr";
import messageModal from "@/components/messageModal";
import educationLoanWebinar from "@/components/educationLoanWebinar";
import webinarWidget from "@/components/webinarWidget";
import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

export default {
    components: {
        messageModal,
        // webinarWidget,
        // educationLoanWebinar
    },
    data() {
        return {
            data: '',
            name: '',
            application_type: '',
            application_enc_id: '',
            cat_name: '',
            profile_icon: '',
            logo: '',
            industry: '',
            amount: '',
            designation: '',
            job_type: '',
            wage_type: '',
            preferred_gender: '',
            experience: '',
            vacancies: '',
            timings_from: '',
            timings_to: '',
            organization_name: '',
            org_slug: '',
            org_email: '',
            working_days: '',
            skills: [],
            job_description: [],
            edu_required: [],
            placement_locations: [],
            interview_locations: [],
            isshortlisted: false,
            hasApplied: false,
            applied_locations: [],
            data_slug: "",
            resumeError: '',
            uploadedResumeId: '',
        }
    },
    mounted() {
        // $('.stick-top').addClass('h-white');

        if (this.$route.query.id) {
            var t = this
            var slug = this.$route.query.id;
            var url = this.$store.getters.getDomain;
            // axios.defaults.headers.post["Content-Type"] = "application/json";

            var bodyFormData = new FormData();
            bodyFormData.set('slug', this.$route.query.id);
            var headers = null;
            if (this.$store.getters.getAuthState) {
                headers = {
                    'Authorization': "Bearer " + localStorage.getItem('token'),
                    'source': localStorage.getItem('source'),
                    'Content-Type': 'application/json'
                }
            } else {
                headers = {
                    'Content-Type': 'application/json'
                }
            }
            axios.post(`${url}api/v2/jobs/application-detail`, {slug: slug}, {
                headers: headers
            })
                .then(function (response) {
                    document.getElementById("h-page-load").classList.add("hides");
                    if (response['data']['response']['status'] == 200) {
                        t.data = response['data']['response']['data'];
                        t.cat_name = response['data']['response']['data']['cat_name'];
                        t.name = response['data']['response']['data']['name'];
                        t.profile_icon = response['data']['response']['data']['icon'];
                        t.logo = response['data']['response']['data']['logo'];
                        t.industry = response['data']['response']['data']['industry'];
                        t.designation = response['data']['response']['data']['designation'];
                        t.job_type = response['data']['response']['data']['type'];
                        t.wage_type = response['data']['response']['data']['wage_type'];
                        t.preferred_gender = response['data']['response']['data']['preferred_gender'];
                        t.experience = response['data']['response']['data']['experience'];
                        t.vacancies = response['data']['response']['data']['vacancies'];
                        t.amount = response['data']['response']['data']['amount'];
                        t.timings_from = response['data']['response']['data']['timings_from'];
                        t.timings_to = response['data']['response']['data']['timings_to'];
                        t.organization_name = response['data']['response']['data']['organization_name'];
                        t.org_slug = response['data']['response']['data']['org_slug'];
                        t.org_email = response['data']['response']['data']['email'];
                        t.working_days = response['data']['response']['data']['working_days'];
                        t.application_enc_id = response['data']['response']['data']['application_enc_id'];
                        if (response['data']['response']['data']['application_type'] == 'Jobs') {
                            t.application_type = 'Job';
                        } else {
                            t.application_type = 'Internship';
                        }
                        for (var i = 0; i < response['data']['response']['data']['applicationSkills'].length; i++) {
                            t.skills.push(response['data']['response']['data']['applicationSkills'][i])
                        }
                        for (var k = 0; k < response['data']['response']['data']['applicationJobDescriptions'].length; k++) {
                            t.job_description.push(response['data']['response']['data']['applicationJobDescriptions'][k])
                        }
                        for (var j = 0; j < response['data']['response']['data']['applicationEducationalRequirements'].length; j++) {
                            t.edu_required.push(response['data']['response']['data']['applicationEducationalRequirements'][j])
                        }
                        for (var p = 0; p < response['data']['response']['data']['applicationPlacementLocations'].length; p++) {
                            t.placement_locations.push(response['data']['response']['data']['applicationPlacementLocations'][p])
                        }
                        for (var q = 0; q < response['data']['response']['data']['applicationInterviewLocations'].length; q++) {
                            t.interview_locations.push(response['data']['response']['data']['applicationInterviewLocations'][q])
                        }
                        if (response['data']['response']['data']['hasShortlisted']) {
                            t.isshortlisted = true;
                        } else {
                            t.isshortlisted = false;
                        }
                        if (response['data']['response']['data']['hasApplied']) {
                            t.hasApplied = true;
                        } else {
                            t.hasApplied = false;
                        }
                    } else if (response['data']['response']['status'] == 404) {
                        alert('Application Not Found!');
                        // if(t.$store.getters.getUserType == 'Individual'){
                        //
                        // } else if (t.$store.getters.getUserType == "teacher"){
                        //
                        // } else{
                        //
                        // }
                        t.$router.go(-1);
                    } else {
                        alert('Unstable internet connection or an error occurred!');
                        window.location.replace("/");
                    }

                })
                .catch(function (error) {
                    // console.log(error)
                })
            t.data_slug = t.$route.query.id;
        }
    },
    computed: {
        multiple_value_boolean() {
            return this.$store.getters.getUserType || this.$store.getters.getUserType == 'Individual';
        }
    },
    methods: {
        shortlist: function (event) {
            var t = this;
            var element = event.currentTarget
            var data_key = element.getAttribute('data-key');
            var url = this.$store.getters.getDomain;
            var slug = this.$route.query.id;
            axios.post(`${url}api/v2/jobs/shortlist-application`, {application_enc_id: data_key}, {
                headers: requestHeaders()
            })
                .then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.isshortlisted = true;
                    } else {
                        t.isshortlisted = false;
                    }
                })
        },
        apply_location: function (events) {
            this.applied_locations = [];
            var items = document.getElementsByClassName('pl-apply-item');
            for (var i = 0; i < items.length; i++) {
                if (items[i].checked) {
                    this.applied_locations.push(items[i].value);
                }
            }
        },
        showApplyModal() {
            $('#modal').modal('show');
        },
        openWhatsapp() {
            var val = document.getElementById('wts-txt').value;
            var location = window.location.href;
            var regexp = /^\d+$/gs;
            if (val.length < 10 || !regexp.test(val)) {
                alert('Enter Valid Number');
            } else {
                window.open('https://api.whatsapp.com/send?phone=' + val + '&text=' + location);
            }
            document.getElementById('wts-txt').value = "";
        },
        validateEnterKey: function (e) {
            if (e.keyCode === 13) {
                this.openWhatsapp();
            }
        },
        showLoginModal() {
            $('#myModal').css({"display": "block"});
        },
        jobApply: function () {
            var t = this;
            var url = this.$store.getters.getDomain;
            var resume_id;
            var resumes = document.getElementsByName('resume_list');
            for (var l = 0; l < resumes.length; l++) {
                if (resumes[l].checked) {
                    resume_id = resumes[l].value;
                }
            }
            if (!resume_id && !t.uploadedResumeId) {
                alert('please select resume');
                return false;
            }
            var checkStep
            var resumeStep = document.getElementsByName('resSteps');
            for (var m = 0; m < resumeStep.length; m++) {
                if (resumeStep[m].checked) {
                    checkStep = resumeStep[m].value;
                }
            }
            if (checkStep == 1 && t.uploadedResumeId) {
                resume_id = t.uploadedResumeId;
            }
            axios.post(`${url}api/v2/jobs/apply`, {
                resume_enc_id: resume_id,
                app_id: t.application_enc_id,
                city_id: t.applied_locations
            }, {
                headers: requestHeaders()
            })
                .then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.hasApplied = true;
                        $('#modal').modal('hide');
                        if (!response['data']['response']['profile'].is_completed) {
                            setTimeout(function () {
                                $('#messageModal').modal('show');
                            }, 1000)
                        }
                    }
                })

        },
        accept: function (event, type, action) {
            var t = this;
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            var url = this.$store.getters.getDomain;
            var data_id = element.getAttribute('data-id');
            axios.post(`${url}api/v2/college-index/job-approve`, {
                application_enc_id: data_key,
                org_enc_id: data_id,
                action: action
            }, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    if (type == "Jobs") {
                        toastr.success('Job ' + action + 'ed Successfully', 'Success');
                    } else {
                        toastr.success('Internship ' + action + 'ed Successfully', 'Success');
                    }
                    if (action == 'Accept') {
                        t.data.is_college_approved = 1;
                    } else {
                        t.data.is_college_deleted = 1;
                    }
                } else {
                    toastr.error('An error occurred try again later.', 'Error');
                }
            })
        },
        alertModal(e) {
            alert(e);
        },
        copyToClipboard(event) {
            var element = event.currentTarget;
            var link = element.getAttribute('href');
            var temp = $("<input>");
            $("body").append(temp);
            temp.val(link).select();
            document.execCommand("copy");
            temp.remove();
            toastr.success('Copied to Clipboard', 'Copied');
        },
        changeCandStatus(event) {
            var t = this;
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/jobs/block-student`, {applied_id: data_key}, {
                headers: requestHeaders()
            })
                .then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Candidate Blocked Successfully', 'Success');
                        t.data.applied_list = response['data']['response']['applied'];
                        t.data.applied_count = response['data']['response']['count'];
                    } else {
                        toastr.error('An error occurred try again later.', 'Error');
                    }
                })
        },
        showResumeSection(event) {
            var elem = event.currentTarget;
            if (elem.value == 0) {
                document.getElementById('use_existing').classList.remove('hidden');
                document.getElementById('new_resume').classList.add('hidden');
            } else {
                document.getElementById('new_resume').classList.remove('hidden');
                document.getElementById('use_existing').classList.add('hidden');
            }
        },
        uploadResume(event) {
            var t = this;
            var elem = event.currentTarget;
            if (document.getElementById("resume_upload").files[0]) {
                var file_val = document.getElementById("resume_upload").files[0].name;
                $(".file-upload-wrapper").attr("data-text", file_val);
                var filePath = document.getElementById("resume_upload").value;

                // Allowing file type
                var allowedExtensions = /(\.doc|\.docs|\.pdf)$/i;

                if (!allowedExtensions.exec(filePath)) {
                    t.resumeError = "Resume file type must be .doc, .docx and .pdf";
                    return false;
                }
                var FileSize = document.getElementById("resume_upload").files[0].size / 1024 / 1024;
                if (FileSize > 2) {
                    t.resumeError = "Resume file size must be less than 2MB";
                    return false;
                }
                t.resumeError = "";
                t.updateResume();
            } else {
                t.resumeError = "";
                $('.file-upload-wrapper').attr('data-text', 'No file chosed');
            }
        },
        updateResume() {
            var t = this;
            var url = this.$store.getters.getDomain;
            let tempResume = document.getElementById("resume_upload").files[0];
            const ru = new FormData();
            ru.append('resume', tempResume);
            showLoader();
            axios.post(`${url}api/v2/cand-profile/upload-resume`, ru, {
                headers: requestHeaders(),
            })
                .then(res => {
                    hideLoader();
                    if (res.status == 200) {
                        t.uploadedResumeId = res['data']['response']['id'];
                        toastr.success('Resume Uploaded Successfully', 'Success');
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                })
        },
    }
}
</script>

<style scoped>
.down-img h3 {
    color: #fff;
    font-size: 15px;
    font-family: roboto;
    margin: 20px 0;
}

.down-img a {
    color: #fff;
    border: 2px solid #fff;
    padding: 8px 25px;
    font-size: 14px;
    font-family: roboto;
    font-weight: 500;
    border-radius: 6px;
}

.down-img a:hover {
    background-color: #fff;
}

.form-control.dash-input {
    padding-right: 34px;
}

.input-wts {
    padding: 0 15px;
    position: relative;
}

.wts-ap h3 {
    font-size: 20px;
    color: #fff;
    font-family: roboto;
    margin: 10px 0 20px;
    font-weight: 400;
}

.input-wts i {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 22px;
    cursor: pointer;
}

.stick-top.forsticky > .menu-sec nav > ul > li > a {
    color: #fff;
}

.stick-top.forsticky.sticky > .menu-sec nav > ul > li > a {
    color: #000;
}

.text-white {
    color: #fff;
}

.p-0 {
    padding: 0 !important;
}

.m-0 {
    margin: 0px !important;
}

.profile_icons img {
    width: 100%;
}

.pl-items {
    display: flex;
    margin: 10px;
}

.pl-items label {
    margin-top: 3px;
    padding-left: 10px;
}

.hvr-icon-pulse {
    display: inline-block;
    vertical-align: middle;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    padding-right: 1.2em;
}

.job-overview ul, .job-details ul {
    list-style: none;
}

.week-days ul li {
    position: relative;
    list-style: none;
    /*display: none;*/
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    margin-right: 5px;
    background-color: #fff !important;
    background-image: none;
    border: 1px solid #ddd;
    color: #000;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    align-content: center;
}

.week-days ul li.active {
    color: #fff;
    display: inline-block;
    background-color: #35394F;
    background-image: linear-gradient(-40deg, #35394F 25%, #787D90);
    border: 1px solid #ddd;
}

.week-days ul li.active h2 {
    color: #fff;
}

.week-days ul li span {
    position: absolute;
    top: 0px;
    line-height: 25px;
    left: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 1px 5px -2px #393d52;

}

.week-days ul li.active span {
    background-color: #787E91;
    box-shadow: 0 5px 5px -5px #393d52;
}

.week-days ul li h2 {
    /*line-height: 115px;*/
    margin: 0px;
    margin-top: 35px;
}

.time-bar-inner {
    line-height: 35px;
    border-radius: 35px;
    padding: 4px;
    background-color: #EE7436;
    background-image: linear-gradient(-40deg, #EA5768, #EE7436 90%);
    border: 5px solid #D9DADA;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
}

.working-time-from {
    width: 15%;
    float: left;
    background-color: #fff;
    color: #EE7436;
    border-radius: 35px;
}

.working-time-to {
    width: 15%;
    float: right;
    background-color: #fff;
    color: #EE7436;
    border-radius: 35px;
}

.working-time-title {
    width: 70%;
    float: left;
}

@media screen and (max-width: 767px) {
    .time-bar-inner {
        font-size: 17px;
    }
}

@media screen and (max-width: 450px) {
    .time-bar-inner {
        font-size: 13px;
    }
}

.p-location-heading {
    width: 100%;
    font-family: Open Sans;
    font-size: 15px;
    color: #202020;
    font-weight: 600;
}

.p-locations li {
    max-width: 125px;
    box-shadow: 0px 1px 10px -2px #ddd;
    background-color: #35394F;
    background-image: linear-gradient(-40deg, #35394F 25%, #787D90);
    display: inline-block;
    margin: 8px;
    box-shadow: 0px 1px 10px -2px #ddd;
}

.p-locations li a {
    color: #222;
    position: relative;
    display: block;
}

.p-locations li a:before, .p-locations li a:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 77%;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    opacity: 0;
    -webkit-transition: opacity 0.7s ease;
    -moz-transition: opacity 0.7s ease;
    -ms-transition: opacity 0.7s ease;
    -o-transition: opacity 0.7s ease;
    transition: opacity 0.7s ease-out;
}

.p-locations li a:before {
    background: url("https://www.empoweryouth.com/assets/themes/ey/images/pages/jobs/direction_icon.png");
    z-index: 2;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 40%;
}

.p-locations li a:after {
    background-color: #000;
}

.p-locations li:hover a:before {
    opacity: 1;
}

.p-locations li:hover a:after {
    opacity: 0.55;
}

.p-locations li a img {
    width: 90%;
    margin-left: 5%;
    padding: 10px;
}

.p-locations li a span {
    font-size: 14px;
    color: #fff;
    padding: 0px 4px;
    height: 35px;
    line-height: 35px;
    width: 100%;
    text-align: center;
    display: block;
    -webkit-transition: all 0.4s ease 0s;
    -moz-transition: all 0.4s ease 0s;
    -ms-transition: all 0.4s ease 0s;
    -o-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;
    background-color: #787E91;
    box-shadow: 0 -10px 5px -5px #393d52;
}

.p-locations li:hover a span {
    background-color: #00a0e3;
    color: #fff;
}

.job-thumb a {
    width: 100px;
    height: 100px;
    background-color: #fff;
    display: block;
    margin: auto;
    border-radius: 50%;
}

.job-thumb a img {
    margin: 5px;
}

.overlay-top {
    width: 70%;
    margin: auto;
    margin-top: -150px;
    float: none;
    background-color: #333a44;
    z-index: 8;
    padding-top: 20px;
    padding-bottom: 50px;
}

.organization-details {
    display: block;
    text-align: left;
    padding: 25px;
}

.organization-details h4 {
    font-size: 14px !Important;
    margin-top: 15px !important;
}

a.add-or-compare {
    display: inline-block !important;
    background-color: #fff;
    padding: 15px 6px;
    width: 175px;
    font-size: 12px;
    border-radius: 2px;
    color: #333;
    margin-top: 15px;
    box-shadow: 0px 0px 10px -2px #ddd;
    -webkit-transition: all 0.4s ease 0s;
    -moz-transition: all 0.4s ease 0s;
    -ms-transition: all 0.4s ease 0s;
    -o-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;
}

a.add-or-compare.half-width {
    width: 42%;
    margin: 0px 2%;
}

a.add-or-compare.half-width.primary {
    background-color: #00a0e3;
    color: #fff;
}

.disabled-section {
    padding: 10px;
    position: relative;
}

.disabled-section:before {
    position: absolute;
    content: "";
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 9;
    opacity: 0.3;
    cursor: not-allowed;
    background-color: #000;
}

a.add-or-compare:hover, a.add-or-compare:focus {
    background-color: #00a0e3;
    color: #fff;
    border-radius: 6px;
}

.add-or-compare i {
    display: block;
}

@media only screen and (max-width: 991px) {
    .job-single-head.style2.overlay-top {
        margin-top: 0;
        width: 100%;
    }

    .job-thumb {
        max-width: 125px;
    }

    .job-head-info .organization-details h4 {
        margin-left: 0px !Important;
    }

    .actions-main {
        display: inline-block;
        width: 42%;
    }
    .btn-parent{
        position: fixed;
        bottom:28px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9;
        background: rgba(0,0,0,.1);
        padding: 7px;
    }
}

@media only screen and (max-width: 720px) {
    .actions-main {
        width: 30%;
        font-size: 11px;
    }
}

@media only screen and (max-width: 640px) {

    .add-or-compare i {
        display: inline-block;
    }
}

@media only screen and (max-width: 640px) {

    .actions-main {
        width: 100%;
    }
}

@media only screen and (max-width: 430px) {
    .job-thumb {
        max-width: inherit;
    }

    .job-head-info {
        max-width: inherit;
        text-align: center;
    }

    .organization-details {
        text-align: center;
    }
}

.has-success .control-label, .has-success.radio-inline label, .has-success .checkbox-inline, .has-success .radio-inline, .has-error .control-label, .has-error.radio-inline label, .has-error .checkbox-inline {
    color: inherit;
}

label.control-label {
    font-family: 'Titillium Web', sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
}

.z-index-9 {
    z-index: 9;
}

#logo_img {
    width: 90px;
    height: 90px;
}

section.overlape {
    z-index: 2;
    position: relative;
}

.dark-color::before {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: '';
    background: #00000078;
    opacity: 0.8;
}

.dark-color::after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: '';
    z-index: -1;
    opacity: 0.14;
}

.inner-header {
    float: left;
    width: 100%;
    position: relative;
    padding-top: 215px;
    padding-bottom: 15px;
    z-index: 0;
}

.inner-header > h3 {
    max-width: 500px;
    position: relative;
    z-index: 1;
    color: #ffffff;
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    margin: auto;
    margin-bottom: 50px;
    text-transform: capitalize;
}

.inner-header .container {
    position: relative;
    z-index: 1;
}

.container {
    padding: 0
}

.inner-header .container {
    position: relative;
    z-index: 1;
}

.job-single-sec {
    float: left;
    width: 100%;
}

.job-single-head2 {
    float: left;
    width: 100%;
}

.job-single-head2 > span {
    float: left;
    width: 100%;
    font-size: 13px;
    color: #888888;
    margin-top: 20px;
}

.job-single-head2 > span strong {
    font-weight: normal;
    color: #202020;
}

.job-details {
    float: left;
    width: 100%;
}

.job-details h3 {
    float: left;
    width: 100%;
    font-family: Open Sans;
    font-size: 15px;
    color: #202020;
    margin-bottom: 15px;
    margin-top: 10px;
    font-weight: 600;
}

.job-details p,
.job-details li {
    float: left;
    width: 100%;
    font-size: 13px;
    color: #fff;
    line-height: 24px;
    margin: 0;
    margin-bottom: 19px;
}

.job-details > ul {
    float: left;
    width: 100%;
    margin-bottom: 20px;
}

.job-details > ul li {
    float: left;
    width: 100%;
    margin: 0;
    margin-bottom: 0px;
    position: relative;
    padding-left: 23px;
    line-height: 21px;
    margin-bottom: 10px;
    font-size: 13px;
    color: #888888;
}

.job-details > ul li::before {
    position: absolute;
    left: 0;
    top: 10px;
    width: 10px;
    height: 1px;
    background: #888888;
    content: '';
}

.job-overview {
    float: left;
    width: 100%;
}

.job-overview > h3 {
    float: left;
    width: 100%;
    font-family: Open Sans;
    font-size: 15px;
    color: #202020;
    font-weight: 600;
}

.job-overview ul {
    float: left;
    width: 100%;
    border: 2px solid #e8ecec;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    margin: 0;
    padding-left: 15px !important;
}

.job-overview ul > li {
    float: left;
    width: 100%;
    margin: 0;
    position: relative;
    padding-left: 67px;
    margin: 8px 0px;
    min-height: 68px;
}

.job-overview ul > li i {
    position: absolute;
    left: 23px;
    top: 5px;
    font-size: 30px;
    color: #4aa1e3;
}

.job-overview ul > li h3 {
    float: left;
    width: 100%;
    font-size: 13px;
    font-family: Open Sans;
    margin: 0;
    color: #1e1e1e;
    font-weight: 600;
}

.job-overview ul > li span {
    float: left;
    width: 100%;
    font-size: 13px;
    color: #545454;
    margin-top: 4px;
}

.job-single-sec .job-overview ul {
    padding: 0;
    margin-bottom: 20px;
}

.job-single-sec .job-overview ul li {
    float: left;
    width: 33.33%;
    padding-left: 50px;
}

.job-single-sec .job-overview ul li i {
    left: 0;
}

.job-overview > a {
    float: left;
    width: 100%;
    height: 50px;
    font-size: 13px;
    background: #ef7706;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.job-overview ul > li:hover i {
    color: #ef7706;
}

.job-overview ul > li *, .job-single-head.style2 > a, .apply-job-btn {
    -webkit-transition: all 0.4s ease 0s;
    -moz-transition: all 0.4s ease 0s;
    -ms-transition: all 0.4s ease 0s;
    -o-transition: all 0.4s ease 0s;
    transition: all 0.4s ease 0s;
}

.job-single-head.style2 {
    display: inherit;
    text-align: center;
    border: none;
}

.job-single-head.style2 .job-thumb {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    margin: auto;
}

.job-single-head.style2 .job-thumb img, .job-single-head.style2 .job-thumb canvas {
    float: none;
    display: inline-block;
    width: auto;
    border: none;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    border-radius: 50%;
}

.job-single-head.style2 .job-head-info {
    width: 100%;
    display: inherit;
    padding: 0;
    margin-top: 10px;
    margin-bottom: 18px;
}

.job-single-head.style2 .job-head-info p {
    float: left;
    width: 100%;
    margin: 0;
    margin-top: 0px;
}

.job-single-head.style2 .job-head-info p i {
    float: none;
    color: #fff;
    display: inline-block;
}

.job-single-head.style2 .job-head-info > span {
    margin-top: 5px;
    margin-bottom: 20px;
}

.job-single-head.style2 > a {
    clear: both;
    display: block;
}

.job-single-head.style2 > a:hover {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    color: #ffffff;
}

.job-thumb img {
    float: left;
    width: 100%;
    border: 2px solid #e8ecec;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
}

.job-head-info {
    display: table-cell;
    vertical-align: middle;
    padding-left: 25px;
}

.job-head-info h4 {
    float: left;
    width: 100%;
    font-family: Open Sans;
    font-size: 17px;
    font-weight: 600;
    color: #fff;
    margin: 0;
    margin-bottom: 0px;
    margin-bottom: 10px;
}

.job-head-info span {
    float: none;
    width: auto;
    font-size: 13px;
    color: #fff;
    line-height: 10px;
}

.job-head-info p {
    float: left;
    margin: 0;
    margin-top: 0px;
    margin-right: 0px;
    font-size: 13px;
    margin-right: 40px;
    color: #888;
    margin-top: 11px;
}

.job-head-info p i {
    float: left;
    font-size: 14px;
    line-height: 27px;
    margin-right: 9px;
    margin-top: 1px;
}

.apply-job-btn {
    background: #00a0e3;
    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.18);
    -moz-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.18);
    -ms-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.18);
    -o-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.18);
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.18);
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    -ms-border-radius: 2px;
    -o-border-radius: 2px;
    border-radius: 2px;
    font-family: Open Sans;
    font-size: 13px;
    color: #fff;
    width: 175px;
    height: auto;
    padding: 15px 6px;
    text-align: center;
    margin: auto;
}

.apply-job-btn:hover {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    color: #fff !important;
}

.apply-job-btn i {
    float: none;
    font-size: 18px;
    margin-right: 6px;
    line-height: 8px;
    position: relative;
    top: 4px;
}

.job-title2 > h3 {
    float: left;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    margin-right: 0px;
    margin-right: 20px;
}

.parallax {
    height: 100%;
    width: 100%;
    margin: 0;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    background-size: cover !important;
}

.parallax.no-parallax {
    background-attachment: scroll !important;
    background-position: inherit !important;
}

.tags-bar {
    float: left;
    width: 100%;
    margin-bottom: 20px;
    border: 2px solid #e8ecec;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    padding: 10px;
    position: relative;
}

.tags-bar > span {
    float: left;
    background: #f4f5fa;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    font-family: Open Sans;
    font-size: 13px;
    padding: 7px 17px;
    margin-right: 15px;
    margin-bottom: 5px;
    position: relative;
}

.shortlist_job, .shortlist_job:hover {
    color: #fff;
}

.shortlist_job:focus {
    color: #fff;
}

@media only screen and (max-width: 575px) {
    .job-overview ul li {
        width: 50% !important;
    }
}

.has-success .control-label, .has-success.radio-inline label, .has-success .checkbox-inline, .has-success .radio-inline, .has-error .control-label, .has-error.radio-inline label, .has-error .checkbox-inline {
    color: inherit;
}

/* Feature, categories css starts */
.row.no-gape > div {
    padding: 0;
}

/* Feature, categories css ends */
/* Profile icons css start */
.profile_icons {
    position: absolute;
    width: 320px;
    left: 0px;
    bottom: -3px;
}

.background-container {
    max-width: 1200px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 80px;
    margin: auto;
}

@media screen and (max-width: 1150px) and (min-width: 1025px) {
    .profile_icons {
        width: 290px;
    }

    .inner-header > h3 {
        width: 400px;
    }

    .inner-header {
        padding-top: 190px;
    }
}

@media screen and (max-width: 1024px) and (min-width: 890px) {
    .profile_icons {
        width: 260px;
    }

    .inner-header {
        padding-top: 160px;
    }

    .inner-header > h3 {
        width: 370px;
    }
}

@media screen and (max-width: 889px) and (min-width: 650px) {
    .profile_icons {
        width: 210px;
    }

    .inner-header > h3 {
        width: 290px;
        font-size: 22px;
        margin-bottom: 20px;
    }

    .inner-header {
        padding-top: 160px;
    }
}

@media screen and (max-width: 649px) and (min-width: 0px) {
    .profile_icons {
        width: 150px;
        position: relative;
        margin: auto;
        left: 0;
        bottom: 0px;
        margin-bottom: 30px;
    }

    .inner-header {
        padding-top: 90px;
    }

    .inner-header > h3 {
        font-size: 20px;
        margin-bottom: 20px;
    }
}

.main-content {
    min-height: 70%;
    min-height: -webkit-calc(100vh - 355px);
    min-height: -moz-calc(100vh - 355px);
    min-height: calc(100vh - 355px);
}

.applied-count {
    margin: 15px 0px;
}

.applied-count a {
    color: #fff;
}

.width-auto {
    width: auto !Important;
}

.portlet {
    margin-bottom: 25px;
    padding: 12px 20px 15px;
    background-color: #fff;
}

.portlet > .portlet-title {
    border-bottom: 1px solid #eee;
    padding: 0;
    margin-bottom: 10px;
    min-height: 48px;
}

.portlet > .portlet-title > .caption {
    float: left;
    display: inline-block;
    font-size: 18px;
    line-height: 18px;
    padding: 10px 0;
    color: #666;
}

.portlet.light > .portlet-title > .caption > .caption-subject {
    font-size: 16px;
    color: #2f353b;
    text-transform: uppercase;
    font-weight: 700;
}

.portlet.light .portlet-body {
    padding-top: 8px;
    clear: both;
}

.mt-comments .mt-comment {
    padding: 10px;
    margin: 0 0 10px;
}

.mt-comments .mt-comment .mt-comment-img {
    width: 40px;
    float: left;
}

.mt-comments .mt-comment .mt-comment-img > img {
    border-radius: 50% !important;
    width: 40px;
    height: 40px;
}

.mt-comments .mt-comment .mt-comment-body {
    padding-left: 10px;
    position: relative;
    /*overflow: hidden;*/
}

.mt-comments .mt-comment .mt-comment-body .mt-comment-info .mt-comment-author {
    display: inline-block;
    /*float: left;*/
    margin: 0 0 10px;
    color: #060606;
    font-weight: 600;
}

.mt-comments .mt-comment .mt-comment-body .mt-comment-info .mt-comment-date {
    display: inline-block;
    float: right;
    background: #00a0e3;
    color: #fff;
    padding: 5px 10px;
    border-radius: 50px;
    font-size: 12px;
}

.mt-comments .mt-comment .mt-comment-body .mt-comment-text {
    color: #999;
}

.block-drp {
    display: inline-block;
    float: right;
}

.block-drp > button {
    background-color: transparent;
}

.file-upload-wrapper {
    position: relative;
    width: 330px;
    height: 50px;
}

.file-upload-wrapper:after {
    content: attr(data-text);
    font-size: 14px;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    padding: 10px 15px;
    display: block;
    width: calc(100% - 40px);
    pointer-events: none;
    z-index: 8;
    height: 48px;
    line-height: 27px;
    border: 2px solid #e8ecec;
    color: #999;
    border-radius: 10px 0px 0px 10px;
    overflow: hidden;
}

.file-upload-wrapper:before {
    content: 'Upload Resume';
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    height: 48px;
    background: #fff;
    color: #555;
    z-index: 9;
    font-size: 13px;
    border: 2px solid #e8ecec;
    line-height: 45px;
    padding: 0 15px;
    pointer-events: none;
    border-radius: 0 10px 10px 0;
}

.file-upload-wrapper:hover:before {
    background: #ff7803;
    color: #fff;
    border-color: #ff7803;
}

.file-upload-wrapper input {
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    height: 60px;
    margin: 0;
    padding: 0;
    display: block;
    cursor: pointer;
    width: 100%;
}

.file-upload-wrapper p.help-block.help-block-error {
    position: absolute;
    margin-top: 55px;
}

@media screen and (max-width: 767px) {
    .file-upload-wrapper {
        width: 295px;
    }
}
</style>